module.exports = __webpack_public_path__ + "img/password_icon.bb3d3fa9.svg";